import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n from '@/services/i18n/i18n';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';

export function WatcherLanguageFromSettingsToBrowser() {
  const { user_settings, is_authorized } = use_slice_user(['user_settings', 'is_authorized']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (!is_authorized) return; //no need to establish for non authorized users
    if (user_settings.regional_language == i18n.language) return; //already established
    if (!CONSTANTS__shared.SUPPORTED_LANGUAGES.includes(user_settings.regional_language)) return; //language is not supported

    void i18n.changeLanguage(user_settings.regional_language);
  }, [user_settings.regional_language, is_authorized]);

  return <></>;
}
